<script setup>
import FormInput from '../../../../../components/Forms/FormInput.vue';
import { computed, ref, watch } from 'vue';

const props = defineProps({
    blocks: {
        type: Array,
        required: true,
    },
    modelValue: {
        type: Array,
        required: true,
    },
});

const contentBlocks = ref(props.blocks);

const emit = defineEmits(['update:modelValue']);

watch(
    contentBlocks,
    () => {
        const tags = contentBlocks.value
            .flatMap((b) => b.sections)
            .flatMap((s) => s.tags)
            .map((tag) => {
                return {
                    id: tag.id,
                    weight: tag.weight,
                };
            })
            .filter((t) => t.weight > 0);
        emit('update:modelValue', tags);
        console.log('tags', tags);
    },
    {
        deep: true,
        immediate: true,
    },
);

const tags = computed(() => {
    return contentBlocks.value
        .flatMap((b) => b.sections)
        .flatMap((s) => s.tags)
        .filter((t) => t.weight > 0);
});

const totalWeight = computed(() => {
    let total = 0;
    contentBlocks.value
        .flatMap((cb) => cb.sections)
        .flatMap((s) => s.tags)
        .filter((t) => t.weight > 0)
        .map((t) => +t.weight)
        .forEach((weight) => {
            total += weight;
        });
    return total;
});

defineOptions({
    name: 'TreemapTagWeightForm',
});
</script>

<template>
    <table class="min-w-full divide-y divide-gray-200">
        <thead>
            <tr class="text-white">
                <th class="px-6 py-3 bg-gray-400 text-left text-xs leading-4 font-medium tracking-wider">
                    {{ $tc('messages.tags', 2) }}
                </th>
                <th class="max-w-xs px-6 py-3 bg-gray-400 text-left text-xs leading-4 font-medium tracking-wider">
                    {{ $t('messages.weight') }}
                </th>
                <th class="max-w-xs px-6 py-3 bg-gray-400 text-left text-xs leading-4 font-medium tracking-wider"></th>
            </tr>
        </thead>
        <template v-for="block in contentBlocks" :key="block.id">
            <thead>
                <tr>
                    <th
                        colspan="3"
                        class="max-w-xs px-6 py-3 bg-gray-300 text-left text-xs leading-4 font-medium text-gray-500 tracking-wider"
                    >
                        {{ block.name }}
                    </th>
                </tr>
            </thead>
            <tbody v-for="section in block.sections" :key="section.name">
                <tr>
                    <td
                        colspan="3"
                        class="max-w-xs px-6 py-3 bg-gray-200 text-left text-xs leading-4 font-medium text-gray-500 tracking-wider"
                    >
                        {{ section.name }}
                    </td>
                </tr>
                <tr v-for="tag in section.tags" :key="tag.id" class="group hover:bg-indigo-50">
                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                        <span>{{ tag.name }}</span>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                        <FormInput v-model.number="tag.weight" type="number" step="1" min="1" max="100" />
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                        <span v-if="tag.weight">{{ Math.round((tag.weight / totalWeight) * 100) }}%</span>
                    </td>
                </tr>
            </tbody>
        </template>
    </table>
</template>
